// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OCJR5DiYHE43eU {
  margin: var(--ds-space-300, 24px) var(--ds-space-0, 0);
  font-weight: var(--ds-font-weight-bold, bold);
  text-align: center;
}
.xdi_dBBDfiXkEz {
  padding: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var noResults = `OCJR5DiYHE43eU`;
export var searchResults = `xdi_dBBDfiXkEz`;
export default ___CSS_LOADER_EXPORT___;
